export default __webpack_public_path__ + "de2464c5fbf9fa39493b8b4e58361c47.woff";